module.exports = __webpack_public_path__ + "img/patec.e54fa53e.jpg";